<!--Main Container Starts-->
<div class="office-profile-container height-100pe" [@routerTransition]>
  <div class="row height-100pe">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">

      <div class="nurse-profile-card-body height-100pe padding-bottom-0px">
        <div class="row height-100pe">
          <div class="col-md-2 height-100pe padding-right-0px">
            <div class="sidebar-unified-card height-100pe">
              <!-- Fixed Profile Avatar Header Box (Never Scrolls) -->
              <div class="sidebar-fixed-header">
                <div class="office-card-header">
                  <!-- Floating Back Arrow Overflow Button on Top-Left -->
                  <button class="floating-back-btn" title="Back To Profile" (click)="BackToProfile()" *ngIf="titleapp !== 'App'">
                    <i class="fas fa-arrow-left"></i>
                  </button>
                  <button class="floating-back-btn" title="Back To Appointments" (click)="BackToApp()" *ngIf="titleapp == 'App'">
                    <i class="fas fa-arrow-left"></i>
                  </button>

                  <div *ngIf="SelectedPatient">
                    <img class="office-avatar-img" [src]="SelectedPatient.PatientImageFile" onError="this.src='dummy.jpg';">
                  </div>
                  <h4 class="office-patient-name" *ngIf="titleapp!=='App'">{{DisplayName}}</h4>
                  <h4 class="office-patient-name" *ngIf="titleapp == 'App' || titleapp == 'cycle'">{{Displaynameapp}}</h4>
                  <p class="office-patient-code" *ngIf="titleapp!=='App'">{{FormattedCode}}</p>
                  <p class="office-patient-code" *ngIf="titleapp == 'App' || titleapp == 'cycle'">{{FormattedCodeapp}}</p>
                </div>

                <div class="office-badge-grid" *ngIf="SelectedPatient">
                  <div class="office-badge-item">
                    <span class="val">{{SelectedPatient.Age}}</span>
                    <span class="lbl">Age</span>
                  </div>
                  <div class="office-badge-item">
                    <span class="val">{{SelectedPatient.Gender}}</span>
                    <span class="lbl">Sex</span>
                  </div>
                  <div class="office-badge-item">
                    <span class="val">{{SelectedPatient.PatientCategory}}</span>
                    <span class="lbl">Category</span>
                  </div>
                </div>
              </div>

              <!-- Scrollable Vertical Navigation Ribbon (Profile to Services/Cycles) -->
              <nav class="office-ribbon-nav office-ribbon-scroll-body">
                <div class="nav nav-tabs office-tabs-container">
                  <a class="nav-item nav-link office-tab-link active" role="tab" data-toggle="pill" href="#ApplicantInfo">
                    <div class="tab-left"><i class="fas fa-user-circle office-tab-icon"></i> Profile</div>
                    <i class="fas fa-chevron-right office-tab-arrow"></i>
                  </a>
                  <a class="nav-item nav-link office-tab-link" role="tab" data-toggle="pill" href="#profileinfo">
                    <div class="tab-left"><i class="fas fa-envelope office-tab-icon"></i> Messages</div>
                    <i class="fas fa-chevron-right office-tab-arrow"></i>
                  </a>
                  <a class="nav-item nav-link office-tab-link" role="tab" data-toggle="pill" href="#documentinfo">
                    <div class="tab-left"><i class="fas fa-folder-open office-tab-icon"></i> Documents</div>
                    <i class="fas fa-chevron-right office-tab-arrow"></i>
                  </a>
                  <a class="nav-item nav-link office-tab-link" role="tab" data-toggle="pill" href="#observationsinfo">
                    <div class="tab-left"><i class="fas fa-notes-medical office-tab-icon"></i> Observations</div>
                    <i class="fas fa-chevron-right office-tab-arrow"></i>
                  </a>
                  <a class="nav-item nav-link office-tab-link" role="tab" data-toggle="pill" href="#Orders">
                    <div class="tab-left"><i class="fas fa-shopping-cart office-tab-icon"></i> Orders</div>
                    <i class="fas fa-chevron-right office-tab-arrow"></i>
                  </a>
                  <a class="nav-item nav-link office-tab-link" role="tab" data-toggle="pill" href="#Prescription">
                    <div class="tab-left"><i class="fas fa-file-prescription office-tab-icon"></i> Prescriptions</div>
                    <i class="fas fa-chevron-right office-tab-arrow"></i>
                  </a>
                  <a class="nav-item nav-link office-tab-link" role="tab" data-toggle="pill" href="#healthrecordinfo">
                    <div class="tab-left"><i class="fas fa-file-medical-alt office-tab-icon"></i> Health Records</div>
                    <i class="fas fa-chevron-right office-tab-arrow"></i>
                  </a>
                  <a class="nav-item nav-link office-tab-link" role="tab" data-toggle="pill" href="#visitview">
                    <div class="tab-left"><i class="fas fa-calendar-check office-tab-icon"></i> Visits</div>
                    <i class="fas fa-chevron-right office-tab-arrow"></i>
                  </a>
                  <a class="nav-item nav-link office-tab-link" role="tab" data-toggle="pill" href="#billprofile">
                    <div class="tab-left"><i class="fas fa-file-invoice-dollar office-tab-icon"></i> Bills</div>
                    <i class="fas fa-chevron-right office-tab-arrow"></i>
                  </a>
                  <a class="nav-item nav-link office-tab-link" role="tab" data-toggle="pill" href="#servicelist">
                    <div class="tab-left"><i class="fas fa-concierge-bell office-tab-icon"></i> Services</div>
                    <i class="fas fa-chevron-right office-tab-arrow"></i>
                  </a>
                  <a class="nav-item nav-link office-tab-link" role="tab" data-toggle="pill" href="#Cycles">
                    <div class="tab-left"><i class="fas fa-sync-alt office-tab-icon"></i> Cycles</div>
                    <i class="fas fa-chevron-right office-tab-arrow"></i>
                  </a>
                </div>
              </nav>
            </div>
          </div>

          <div class="col-md-10 padding-left-0px padding-right-0px primary-background">
            <div class="tab-content">


              <div class="tab-pane container active margin0px-max-width-100" id="ApplicantInfo" role="tabpanel">

                <div class="margin-left-0px" id="advanced-form" action="#">
                  <!--<h3><span class="s-title"><span class="xs-hide">Personal Info</span> <span class="s-icon"><i class="fas fa-caret-up top-arrow"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
      <fieldset class="margin-top-10">
        <div>
          <legend>Personal Info</legend>



        </div>
      </fieldset>-->
                  <!--<div class="img-one">
        <img src="../../../../../../../wwwroot/healins-assets/images/admin/profile-pic.jpg" class="img-circle" />
        <label>
          Lily Thomas
        </label>

        <label>JOB1</label>
      </div>-->
                  <!--<div class="">
        <img src="../../../../../../../wwwroot/healins-assets/images/admin/profile-pic.jpg" class="img-width" />
        <label>Lilly Thoms</label>
        <label>JOb1</label>
      </div>-->
                  <!-- step-1 -->
                  <!--<h3><span class="s-title"><span class="xs-hide">Personal Info</span> <span class="s-icon"><i class="fas fa-caret-up top-arrow"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>-->
                  <fieldset class="margin-top-10 padding-top-0px margin-left-0px padding-left-0px">
                    <div *ngIf="SelectedPatient" class="margin-left-0px">
                      <!--<legend>Personal Info</legend>-->

                      <personaldetailview [FormattedCode]="SelectedPatient.FormattedCode" [ActorCode]="SelectedPatient.ActorCode"></personaldetailview>

                    </div>
                  </fieldset>
                  <!--<h3><span class="s-title"><span class="xs-hide">Guardian</span> <span class="s-icon"><i class="fas fa-caret-up top-arrow"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
      <fieldset class="margin-top-10">
        <div *ngIf="SelectedPatient">
          <legend>Guardian</legend>

          <guardianinfoview [ActorCode]="SelectedPatient.ActorCode"></guardianinfoview>

        </div>
      </fieldset>-->
                  <!-- Step2 -->
                  <!--<h3 ><span class="s-title"><span class="xs-hide">Vital Signs</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
      <fieldset class="margin-top-10 padding-top-0px" hidden>
        <div *ngIf="SelectedPatient">
          <legend>Vital Signs</legend>
          <vitals [FormattedCode]="SelectedPatient.FormattedCode"></vitals>

        </div>
      </fieldset>-->
                  <!--<h3 hidden><span class="s-title"><span class="xs-hide">Helath Records</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
      <fieldset class="margin-top-10" hidden>
        <div *ngIf="SelectedPatient">
          <legend>Health Records</legend>

          <viewedittext [FormattedCode]="SelectedPatient.FormattedCode"></viewedittext>


        </div>
      </fieldset>-->
                  <!--<h3 hidden><span class="s-title"><span class="xs-hide">Emergency</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
      <fieldset class="margin-top-10" hidden>
        <div *ngIf="SelectedPatient">
          <legend>Emergency</legend>
          <emergencyinfoview [ActorCode]="SelectedPatient.ActorCode"></emergencyinfoview>

        </div>
      </fieldset>-->
                  <!--<h3 hidden><span class="s-title"><span class="xs-hide">Referral</span> <span class="s-icon"><i class="fas fa-caret-up top-arrow"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
      <fieldset class="margin-top-10 padding-top-0px" hidden>
        <div *ngIf="SelectedPatient">
          <legend>Referral</legend>

          <referralview [ActorCode]="SelectedPatient.ActorCode"></referralview>

        </div>
      </fieldset>-->
                  <!-- Step3 -->
                  <!--<h3><span class="s-title"><span class="xs-hide">Documents</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
      <fieldset class="margin-top-10">
        <div *ngIf="SelectedPatient">
          <legend>Documents</legend>
          <otherdatainfo [ActorCode]="SelectedPatient.ActorCode"></otherdatainfo>

        </div>
      </fieldset>-->
                  <!-- Step4 -->
                  <!-- Step5 -->
                  <!--<h3><span class="s-title"><span class="xs-hide">Observations</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
      <fieldset class="margin-top-10">
        <div>
          <legend>Observations</legend>
          <observationsinfov2view></observationsinfov2view>


        </div>
      </fieldset>-->
                </div>
              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px padding-left-0px margin-top-10" id="profileinfo" role="tabpanel">
                <div class="row">
                  <div class="col-md-7">

                    <div class="card">
                      <div class="row">

                        <div class="col-md-12">
                          <div class="card">
                            <div class="card-header wh-header border-bottom1px-solidgray border-left15px-solidgray font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px">
                              <label class="margin-bottom-0px color-backarrow font-size-25px font-weight-bold">Messages</label>
                              
                            </div>
                            <div class="card-body padding-top-0px padding-right-0px">

                              <div class="chatsd product-chart-wrapper agreement-chart-wrapper ps ps2 padding-lrt height-500px" data-ps-id="dfsfsde">
                                <div *ngFor="let l of CurrentCustomerMessageController">
                                  <div class="row margin-bottom-10px margin-top-10" *ngIf="l.Who2Who=='FromProvider'">
                                    <div class="offset-md-6 col-md-5 text-align-right border-right-sender">


                                      <div class="row">
                                        <div class="col-md-12 padding-left-11px">
                                          <label class="font-size-12px margin-bottom-0px date-color-contracts">{{l.CreatedTimeStamp|date:'dd MMM'}}</label>
                                          <div>
                                            <label class="margin-bottom-0px margin-left-5px font-size-12px color-secondary  padding-left-0px">{{l.Purpose}}</label>
                                          </div>
                                        </div>
                                        <!--<div class="col-md-8 text-align-right">

                            </div>-->
                                      </div>


                                      <div class="message-sender">

                                        <div class="row">
                                          <div class="col-md-12 margin-top-4px  font-size-13px text-align-justify">
                                            {{l.MessageText}}


                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row margin-bottom-10px margin-top-10" *ngIf="l.Who2Who=='FromPatient'">
                                    <!--*ngIf="l.Who2Who=='FromPatient'"-->
                                    <div class="offset-md-1 col-md-8 border-left-recevier">
                                      <div class="row">
                                        <div class="col-md-12 padding-left-11px">
                                          <label class="font-size-12px margin-bottom-0px date-color-contracts">{{l.CreatedTimeStamp|date:'dd MMM'}}</label>
                                          <div>
                                            <label class="margin-bottom-0px margin-left-5px font-size-12px color-secondary  padding-left-0px">{{l.Purpose}}</label>
                                          </div>
                                        </div>
                                        <!--<div class="col-md-8 text-align-right">

                            </div>-->
                                      </div>
                                      <div class="receiver">
                                        <!--<div class="row">
                              <div class="col-md-12">
                                <div class="row">
                                  <div class="col-md-6 padding-left-11px">
                                    <label class="margin-bottom-0px margin-left-5px font-size-13px color-secondary  padding-left-0px">{{l.Purpose}}</label>
                                  </div>
                                  <div class="col-md-6 text-align-right">
                                    <label class="font-size-13px margin-bottom-0px date-color-contracts">{{l.CreatedTimeStamp|date:'dd MMM'}}</label>
                                  </div>
                                </div>
                              </div>
                            </div>-->

                                        <div class="row">
                                          <div class="col-md-12 margin-top-4px  font-size-13px text-align-justify">
                                            {{l.MessageText}}

                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>


                    </div>





                  </div>
                  <div class="col-md-5 padding-left-0px">
                    <div class="card affix my-profile-form">
                      <div class="card-header wh-header border-bottom1px-solidgray border-left15px-solidgray font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px">
                        <div class="row">


                          <div class="col-md-8">

                            <label class="margin-bottom-0px color-backarrow font-size-25px">Message To Patient</label>
                            
                          </div>
                          <div class="col-md-4">
                            <a class="nav-link-hand education-navlink float-right">
                              <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="card-body margin-left-zero padding-left-0px padding-right-0px">
                        <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                          <div class="row margin-bottom-10px margin-left-auto">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-4 text-align-right margin-tg-auto">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"> Purpose</label>
                                </div>


                                <div class="col-md-6">
                                  <CodeTypeValue CodeType="PRPS" id="CurrentSaveCustomerMessageRequest.Purpose"
                                                 [(ngModel)]="CurrentSaveCustomerMessageRequest.Purpose" SelectedValue=""
                                                 name="CurrentSaveCustomerMessageRequest.Purpose"></CodeTypeValue>
                                  <!--id="CurrentActorPersonalDetailInfoRequest.MaritalStatus"
                      [(ngModel)]="CurrentActorPersonalDetailInfoRequest.MaritalStatus" SelectedValue="{{CurrentActorPersonalDetailInfoRequest.MaritalStatus}}"
                      name="CurrentActorPersonalDetailInfoRequest.MaritalStatus"-->

                                </div>
                              </div>


                            </div>

                          </div>

                          <div class="row margin-left-auto margin-bottom-10px">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-4 text-align-right">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Message</label>
                                </div>

                                <div class="col-md-6">
                                  <textarea class="form-control3 size-2 width-remarks-206px" rows="2" placeholder="Message" name="CurrentSaveCustomerMessageRequest.MessageText"
                                            [(ngModel)]="CurrentSaveCustomerMessageRequest.MessageText" minlength="1" maxlength="200"
                                            #addconcerns_text="ngModel"></textarea>

                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <button *ngIf='!isRequesting' class="btn button-Schedule actions-btn-prime nav-link-hand cancel-two margin-left-0px margin-right-5px margin-left-auto">Cancel</button>
                            <button type="submit" class="btn font-size-13px actions-btn-prime  margin-right-auto">Send</button>
                          </div>
                        </form>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px" id="documentinfo" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <otherdatainfo [ActorCode]="SelectedPatient.ActorCode"></otherdatainfo>

                </div>
              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px padding-left-0px" id="observationsinfo" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <patinettestview [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></patinettestview>

                </div>
              </div>
              <div class="tab-pane margin-left-0px margin-right-0px padding-right-0px" id="Orders" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <ordersprofile [ActorCode]="SelectedPatient.ActorCode"
                                 [FormattedCode]="SelectedPatient.FormattedCode"
                                 [PatientCode]="SelectedPatient.PatientRegistrationNumber"
                                 [PatientName]="SelectedPatient.DisplayName"></ordersprofile>

                </div>
              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px" id="Prescription" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <prescriptionview [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></prescriptionview>

                </div>
              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px" id="healthrecordinfo" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <viewedittext [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></viewedittext>

                  <!--<visitview [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></visitview>-->

                </div>
              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px" id="visitview" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <!--<medicalrecordview [ActorCode]="SelectedPatient.ActorCode"
      [FormattedCode]="SelectedPatient.FormattedCode"
      ></medicalrecordview>-->
                  <visitview [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></visitview>

                </div>
              </div>
              <div class="tab-pane container margin-right-0px margin-left-0px" id="billprofile" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <billprofile [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode"></billprofile>

                </div>
              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px padding-right-0px" id="servicelist" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <servicesview [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></servicesview>

                </div>
              </div>
              <div class="tab-pane container margin-left-0px margin-right-0px padding-right-0px" id="Cycles" role="tabpanel">

                <div *ngIf="SelectedPatient">
                  <cyclesprofile [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></cyclesprofile>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!--User Profile wizardEnd-->
</div>
<!--<providerdashboard *ngIf="showdashboard" hidden></providerdashboard>-->
<!--Main COintainer ends-->
<!--<div *ngIf="IsSetAccessRights">-->
<!--<div *ngIf="0 == 1">

  <section id="user-profile">
    <div class="row">
      <div class="col-12">
        <div class="card profile-with-cover">
          <div class="media profil-cover-details row">
            <div class="col-6">
              <div class="align-self-start halfway-fab pl-3 pt-2">
                <div class="text-left">
                  <h3 class="card-title pink mb-4">{{CurrentActorProfileController.DisplayName}}</h3>
                </div>
              </div>
            </div>

            <div class="col-6">

            </div>
          </div>
          <div class="profile-section">
            <div class="row">
              <div class="col-lg-6 col-md-6 ">
                <ul class="profile-menu no-list-style">
                  <li>
                    <a (click)="showPage('About')" [ngClass]="currentPage === 'About' ? 'primary font-medium-2 font-weight-600 active' : 'primary font-medium-2 font-weight-600'">Profile</a>
                  </li>
                  <li>
                    <a (click)="showPage('Friends')" [ngClass]="currentPage === 'Friends' ? 'primary font-medium-2 font-weight-600 active' : 'primary font-medium-2 font-weight-600'">Registries</a>
                  </li>

                </ul>
              </div>
              <div class="col-lg-6 col-md-6">
                <ul class="profile-menu no-list-style"></ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="about" *ngIf="currentPage === 'About'">

    <div class="row">
      <div class="col-sm-12">
        <profilesummary [ActorCode]='CurrentActorProfileController.ActorCode'
                        [CanEdit]='CanEditProfileSummary' [CanShow]='CanShowProfileSummary'
                        *ngIf="CurrentActorProfileController.ActorCode >0"></profilesummary>


      </div>

      <div class="col-sm-12">
        <personalinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                      [CanEdit]='CanEditProfileInfo' [CanShow]='CanShowProfileInfo'
                      (personalInfoChange)="onpersonalInfoChange($event)" *ngIf="CurrentActorProfileController.ActorCode >0"></personalinfo>
      </div>
      <div class="col-sm-12">

        <contactinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                     [CanEdit]='CanEditContactInfo' [CanShow]='CanShowContactInfo'
                     *ngIf="CurrentActorProfileController.ActorCode >0"></contactinfo>


      </div>
      <div class="col-sm-12">
        <employmentpreferences [ActorCode]='CurrentActorProfileController.ActorCode'
                               [CanEdit]='CanEditJobPreferences' [CanShow]='CanShowJobPreferences'
                               *ngIf="CurrentActorProfileController.ActorCode >0"></employmentpreferences>

      </div>
      <div class="col-sm-12">

        <div class="row">
          <div class="col-sm-6">
            <legalinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                       [CanEdit]='CanEditLegalinfo' [CanShow]='CanShowLegalinfo'
                       *ngIf="CurrentActorProfileController.ActorCode >0"></legalinfo>
          </div>
          <div class="col-sm-6">
            <educationinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                           [CanEdit]='CanEditEducation' [CanShow]='CanShowEducation'
                           *ngIf="CurrentActorProfileController.ActorCode >0"></educationinfo>
          </div>
        </div>
      </div>

      <div class="col-sm-12">

        <div class="row">
          <div class="col-sm-6">
            <employeehistoryinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                                 [CanEdit]='CanEditEmploymentHistory' [CanShow]='CanShowEmploymentHistory'
                                 *ngIf="CurrentActorProfileController.ActorCode >0"></employeehistoryinfo>
          </div>
          <div class="col-sm-6">
            <professionalreference [ActorCode]='CurrentActorProfileController.ActorCode'
                                   [CanEdit]='CanEditReferences' [CanShow]='CanShowReferences'
                                   *ngIf="CurrentActorProfileController.ActorCode >0"></professionalreference>
          </div>
        </div>
      </div>

      <div class="col-sm-12">

        <div class="row">
          <div class="col-sm-6">
            <identitiesinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                            [CanEdit]='CanEditIdentities' [CanShow]='CanShowIdentities'
                            *ngIf="CurrentActorProfileController.ActorCode >0"></identitiesinfo>
          </div>
          <div class="col-sm-6">
            <certificationsinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                                [CanEdit]='CanEditCertifications' [CanShow]='CanShowCertifications'
                                *ngIf="CurrentActorProfileController.ActorCode >0"></certificationsinfo>
          </div>
        </div>
      </div>

      <div class="col-sm-12">

        <medicalfitnessinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                            [CanEdit]='CanEditMedicalFitness' [CanShow]='CanShowMedicalFitness'
                            *ngIf="CurrentActorProfileController.ActorCode >0"></medicalfitnessinfo>


      </div>

    </div>
  </section>
  <section id="timeline" *ngIf="currentPage === 'TimeLine'">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">

        </div>
        <div class="card-body">
          <employmentpreferences [ActorCode]='CurrentActorProfileController.ActorCode' *ngIf="CurrentActorProfileController.ActorCode >0"></employmentpreferences>

        </div>
      </div>

    </div>
  </section>
  <section id="timeline" *ngIf="currentPage === 'Friends'">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">

        </div>
        <div class="card-body">
          <registryview [NurseActorCode]='CurrentActorProfileController.ActorCode'></registryview>

        </div>
      </div>

    </div>
  </section>
</div>-->
